import { BASE_NAME, getParamFromUrl } from '@/infrastructure/history';

// 允许跳转的域名列表（安全考虑）
const urlWhiteList = [
  'local.tds.qq.com',
  'local.frontarc.ai',
  'local.qualix.frontarc.ai',
  't.bugly.tds.qq.com',
  'bugly.tds.qq.com',
  'local.internal.shiply.tds.qq.com',
  'internal-test.shiply.tds.qq.com',
  'internal.shiply.tds.qq.com',
  'local.shiply.tds.qq.com',
  'test.shiply.tds.qq.com',
  'shiply.tds.qq.com',
  'pre.bugly.tds.qq.com',
  'internal.bugly.qq.com',
  't.internal.bugly.qq.com',
];

export const redirectToPrevPage = () => {
  const redirectURL = decodeURIComponent(getParamFromUrl('url'));
  const url = new URL(redirectURL);

  // 不在白名单的域名不跳转
  if (!urlWhiteList.includes(url.hostname)) {
    console.error(`不允许跳转的地址: ${url.toString()}`);
    return;
  }

  window.location.href = redirectURL || `${BASE_NAME}/overview`;
};
